import { render, staticRenderFns } from "./ForwardMessage.vue?vue&type=template&id=6d128e65&scoped=true"
import script from "./ForwardMessage.vue?vue&type=script&lang=js"
export * from "./ForwardMessage.vue?vue&type=script&lang=js"
import style0 from "./ForwardMessage.vue?vue&type=style&index=0&id=6d128e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d128e65",
  null
  
)

export default component.exports